module.exports = __webpack_public_path__ + "img/logo-en.ef5fb7c1.svg";